import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_bottom_sheet = _resolveComponent("v-bottom-sheet")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createBlock(_component_v_bottom_sheet, {
    persistent: "",
    scrollable: "",
    modelValue: _ctx.opened,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.opened) = $event)),
    width: "500",
    "content-class": "bottom-sheet-centered"
  }, {
    activator: _withCtx(({ props }) => [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["filter-bottom-btn", _ctx.fixedBottom ? 'fixed-bottom' : ''])
      }, [
        _createVNode(_component_v_btn, _mergeProps(props, {
          class: "v-btn--filter",
          elevation: "2"
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              start: "",
              color: "grey"
            }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-filter")
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(" Filter")
          ], undefined, true),
          _: 2
        }, 1040)
      ], 2)), [
        [_directive_touch, {
        up: () => _ctx.opened = true
      }]
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.component)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), {
            key: 0,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.opened = false))
          }, null, 32))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }, 8, ["modelValue"]))
}